// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3sXJz","content":"LayoutSettings_content__3_2cj"};